import { IframeMessageProxy } from 'iframe-message-proxy';
import IMPContainer from '../constants/iframe-message-proxy-container';
import { filterBlankObject, filterPromiseArray } from '../utils/object';

const PORTAL_RECIPIENT = 'postmaster@portal.blip.ai';
const APPLICATIONS_PATH = `/applications`;

const getApplicationDataAsync = async (fullIdentity = null) => {
    const { response: application } = await IframeMessageProxy.sendMessage({
        action: IMPContainer.Actions.GET_APPLICATION,
        content: fullIdentity
    });
    return application;
};

const getCurrentLanguageAsync = async () => {
    const { response } = await IframeMessageProxy.sendMessage({
        action: IMPContainer.Actions.GET_CURRENT_LANGUAGE
    });

    return response;
};

const getBotDataAsync = async (identity) => {
    try {
        const { response } = await IframeMessageProxy.sendMessage({
            action: IMPContainer.Actions.SEND_COMMAND,
            content: {
                destination: IMPContainer.Destinations.BLIP_SERVICE,
                command: {
                    method: IMPContainer.CommandMethods.GET,
                    to: PORTAL_RECIPIENT,
                    uri: `${APPLICATIONS_PATH}/${identity}`
                }
            }
        });

        const data = { ...response, identity };

        return data;
    } catch (err) {
        return false;
    }
};

const getAllowedSubbotsAsync = async (application) => {
    const {
        applicationJson: { settings: appSettings }
    } = application;

    if (!!appSettings?.children) {
        const identities = appSettings.children.map((bot) => bot.identity);
        const promises = identities.map((identity) => getBotDataAsync(identity));
        const result = await Promise.allSettled(promises);
        const subbotsData = filterPromiseArray(result);
        const subbotsList = filterBlankObject(subbotsData);

        return subbotsList;
    }

    return false;
};

export { getApplicationDataAsync, getCurrentLanguageAsync, getBotDataAsync, getAllowedSubbotsAsync };
